import * as React from 'react';
import { IProcessAktivitet } from '../../../../Types/ProcessModel';
import { Roles } from '../../../../Model/ProcessModel/Roles';
import EDGrid from '../../../../BaseComponents/GridComponents/EDGrid';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import ActivityCard, { InfoType } from '../ActivtiyCard/ActivityCard';
import ActivityPanel from '../ActivityPanel/ActivityPanel';

interface IProps {
  activity: IProcessAktivitet;
  showTabs: boolean;
  activeTab: number;
  onTabChange: (tab: number) => void;
}

const Result: React.FunctionComponent<
  React.PropsWithChildren<{ name: string; type: InfoType }>
> = ({ name, type }) => {
  return (
    <EDGrid
      item
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      wrap="nowrap"
    >
      <EDGrid item>
        <EDIcon color="disabled" iconType="arrow_forward" />
      </EDGrid>
      <EDGrid item style={{ flex: '1 1 auto' }}>
        <ActivityCard type={type}>
          <EDTypography>{name}</EDTypography>
        </ActivityCard>
      </EDGrid>
    </EDGrid>
  );
};

/**
 * Komponent som visar en aktivitet med tabbar för att byta innehåll och en punktmeny
 */
class Activity extends React.Component<IProps> {
  getRoleNames(roleIds: number[]): string {
    return roleIds.map(x => `(${x}) ${Roles[x.toString()]}`).join(', ');
  }

  render() {
    const activity = this.props.activity;
    return (
      <EDGrid item xs={12}>
        <ActivityPanel
          title={activity.Rubrik}
          subtitle={activity.Underrubrik}
          showTabs={this.props.showTabs}
          activeTab={this.props.activeTab}
          onTabChange={this.props.onTabChange}
        >
          <EDGrid
            item
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            wrap="nowrap"
          >
            <EDGrid item xs={6}>
              {!!activity.Beskrivning && (
                <ActivityCard type={InfoType.description}>
                  <EDTypography>{activity.Beskrivning}</EDTypography>
                </ActivityCard>
              )}
            </EDGrid>
            <EDGrid
              item
              container
              direction="column"
              justifyContent="space-between"
              alignItems="flex-start"
              wrap="nowrap"
              xs={6}
            >
              {!!activity.NegativtResultat && (
                <Result
                  name={activity.NegativtResultat}
                  type={InfoType.manual}
                />
              )}

              {!!activity.PositivtResultat && (
                <Result
                  name={activity.PositivtResultat}
                  type={InfoType.result}
                />
              )}
            </EDGrid>
          </EDGrid>
        </ActivityPanel>
      </EDGrid>
    );
  }
}

export default Activity;
